// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var ListUtils$SmartcutsMacros = require("../../../bs-utils/src/ListUtils.bs.js");
var DOM__Search$SmartcutsMacros = require("../devProtocol/DOM__Search.bs.js");
var DOM__Shadow$SmartcutsMacros = require("../DOM__Shadow.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");
var DOM__Element$SmartcutsMacros = require("../DOM__Element.bs.js");
var TextContents$SmartcutsMacros = require("../TextContents.bs.js");
var SelectionSemantics__Shared$SmartcutsMacros = require("./SelectionSemantics__Shared.bs.js");
var SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros = require("./SelectionSemantics__NonInputSelectionSemantics.bs.js");

function t_encode(v) {
  if (typeof v === "number") {
    return ["SelectAll_InsideContenEditable"];
  }
  switch (v.TAG | 0) {
    case /* SelectAll_FromNthParagraph */0 :
        return [
                "SelectAll_FromNthParagraph",
                Decco.intToJson(v._0)
              ];
    case /* SelectAll_ToNthParagraphEnds */1 :
        return [
                "SelectAll_ToNthParagraphEnds",
                Decco.intToJson(v._0)
              ];
    case /* SelectAll_AfterPrefixInNthParagraph */2 :
        return [
                "SelectAll_AfterPrefixInNthParagraph",
                Decco.stringToJson(v._0),
                Decco.intToJson(v._1)
              ];
    case /* SelectAll_BeforeSuffixInNthParagraph */3 :
        return [
                "SelectAll_BeforeSuffixInNthParagraph",
                Decco.stringToJson(v._0),
                Decco.intToJson(v._1)
              ];
    case /* SelectInNthParagraph */4 :
        return [
                "SelectInNthParagraph",
                Decco.intToJson(v._0),
                SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.t_encode(v._1)
              ];
    case /* SelectParagraphs */5 :
        return [
                "SelectParagraphs",
                Decco.intToJson(v._0),
                Decco.intToJson(v._1)
              ];
    case /* SelectBetweenIndexes */6 :
        var v1 = v._1;
        var v0 = v._0;
        return [
                "SelectBetweenIndexes",
                [
                  Decco.intToJson(v0[0]),
                  Decco.intToJson(v0[1])
                ],
                [
                  Decco.intToJson(v1[0]),
                  Decco.intToJson(v1[1])
                ]
              ];
    
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "SelectAll_AfterPrefixInNthParagraph" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* SelectAll_AfterPrefixInNthParagraph */2,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "SelectAll_BeforeSuffixInNthParagraph" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* SelectAll_BeforeSuffixInNthParagraph */3,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$2 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "SelectAll_FromNthParagraph" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectAll_FromNthParagraph */0,
                      _0: v0._0
                    }
                  };
          }
          var e$4 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "SelectAll_InsideContenEditable" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* SelectAll_InsideContenEditable */0
                  };
          }
      case "SelectAll_ToNthParagraphEnds" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectAll_ToNthParagraphEnds */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$5 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "SelectBetweenIndexes" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var json = Belt_Array.getExn(jsonArr$1, 1);
          var match$5 = Js_json.classify(json);
          var match$6;
          if (typeof match$5 === "number" || match$5.TAG !== /* JSONArray */3) {
            match$6 = Decco.error(undefined, "Not a tuple", json);
          } else {
            var match$7 = match$5._0;
            if (match$7.length !== 2) {
              match$6 = Decco.error(undefined, "Incorrect cardinality", json);
            } else {
              var v0$2 = match$7[0];
              var v1 = match$7[1];
              var match$8 = Decco.intFromJson(v0$2);
              var match$9 = Decco.intFromJson(v1);
              if (match$8.TAG === /* Ok */0) {
                if (match$9.TAG === /* Ok */0) {
                  match$6 = {
                    TAG: /* Ok */0,
                    _0: [
                      match$8._0,
                      match$9._0
                    ]
                  };
                } else {
                  var e$6 = match$9._0;
                  match$6 = {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$6.path,
                      message: e$6.message,
                      value: e$6.value
                    }
                  };
                }
              } else {
                var e$7 = match$8._0;
                match$6 = {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
              }
            }
          }
          var json$1 = Belt_Array.getExn(jsonArr$1, 2);
          var match$10 = Js_json.classify(json$1);
          var match$11;
          if (typeof match$10 === "number" || match$10.TAG !== /* JSONArray */3) {
            match$11 = Decco.error(undefined, "Not a tuple", json$1);
          } else {
            var match$12 = match$10._0;
            if (match$12.length !== 2) {
              match$11 = Decco.error(undefined, "Incorrect cardinality", json$1);
            } else {
              var v0$3 = match$12[0];
              var v1$1 = match$12[1];
              var match$13 = Decco.intFromJson(v0$3);
              var match$14 = Decco.intFromJson(v1$1);
              if (match$13.TAG === /* Ok */0) {
                if (match$14.TAG === /* Ok */0) {
                  match$11 = {
                    TAG: /* Ok */0,
                    _0: [
                      match$13._0,
                      match$14._0
                    ]
                  };
                } else {
                  var e$8 = match$14._0;
                  match$11 = {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$8.path,
                      message: e$8.message,
                      value: e$8.value
                    }
                  };
                }
              } else {
                var e$9 = match$13._0;
                match$11 = {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
              }
            }
          }
          if (match$6.TAG === /* Ok */0) {
            if (match$11.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* SelectBetweenIndexes */6,
                        _0: match$6._0,
                        _1: match$11._0
                      }
                    };
            }
            var e$10 = match$11._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$10.path,
                      message: e$10.message,
                      value: e$10.value
                    }
                  };
          }
          var e$11 = match$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      case "SelectInNthParagraph" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$15 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$16 = SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$15.TAG === /* Ok */0) {
            if (match$16.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* SelectInNthParagraph */4,
                        _0: match$15._0,
                        _1: match$16._0
                      }
                    };
            }
            var e$12 = match$16._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$12.path,
                      message: e$12.message,
                      value: e$12.value
                    }
                  };
          }
          var e$13 = match$15._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "SelectParagraphs" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$17 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$18 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$17.TAG === /* Ok */0) {
            if (match$18.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* SelectParagraphs */5,
                        _0: match$17._0,
                        _1: match$18._0
                      }
                    };
            }
            var e$14 = match$18._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$14.path,
                      message: e$14.message,
                      value: e$14.value
                    }
                  };
          }
          var e$15 = match$17._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$15.path,
                    message: e$15.message,
                    value: e$15.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function selectInsideContentEditable(contentEditableHost, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
  var applySelection = function (startNode, endNode, startOffset, endOffset) {
    if (startNode === undefined) {
      return Util$SmartcutsMacros.logAndRaiseJsError("Expected to find both startNode and endNode while ContentEditableSelectionSemantics.Semantic.selectInsideContentEditable()");
    }
    if (endNode === undefined) {
      return Util$SmartcutsMacros.logAndRaiseJsError("Expected to find both startNode and endNode while ContentEditableSelectionSemantics.Semantic.selectInsideContentEditable()");
    }
    var maybeSelection = window.getSelection();
    var range = document.createRange();
    range.setStart(Caml_option.valFromOption(startNode), startOffset);
    range.setEnd(Caml_option.valFromOption(endNode), endOffset);
    if (!(maybeSelection == null)) {
      if (maybeSelection.rangeCount > 0) {
        maybeSelection.removeAllRanges();
      }
      maybeSelection.addRange(range);
    }
    return Promise.resolve({
                TAG: /* Ok */0,
                _0: undefined
              });
  };
  var element = DOM__Shadow$SmartcutsMacros.getActiveElementForDocument(undefined);
  if (element !== undefined && Caml_obj.caml_equal(Caml_option.valFromOption(element), contentEditableHost)) {
    
  } else {
    Util$SmartcutsMacros.logAndRaiseJsError("Expected contentEditableHost be document.activeElement when selectInsideContentEditable()");
  }
  var textContents = TextContents$SmartcutsMacros.ForPlayback.fromElement(contentEditableHost);
  var nodeOfTextSegmentAtIndex = function (index) {
    var match = Belt_List.get(textContents, index);
    if (match === undefined) {
      return ;
    }
    if (match.TAG === /* TextSegment */0) {
      var element = match._0;
      if (element.TAG !== /* NonEmptySegment */0) {
        return Caml_option.some(element._0);
      }
      var match$1 = element._0;
      return Caml_option.nullable_to_opt(match$1.parentElement.childNodes.item(match$1.textNodeIndex));
    }
    var element$1 = match._0;
    if (element$1.TAG === /* NonEmptySegment */0) {
      return Caml_option.nullable_to_opt(element$1._0.parentElement.firstChild);
    } else {
      return Caml_option.some(element$1._0);
    }
  };
  var nodeAndEndOffsetOfTextSegmentAtIndex = function (index) {
    var match = Belt_List.get(textContents, index);
    if (match === undefined) {
      return [
              undefined,
              0
            ];
    }
    if (match.TAG === /* TextSegment */0) {
      var element = match._0;
      if (element.TAG !== /* NonEmptySegment */0) {
        return [
                Caml_option.some(element._0),
                0
              ];
      }
      var match$1 = element._0;
      return [
              Caml_option.nullable_to_opt(match$1.parentElement.childNodes.item(match$1.textNodeIndex)),
              match$1.text.length
            ];
    }
    var element$1 = match._0;
    if (element$1.TAG !== /* NonEmptySegment */0) {
      return [
              Caml_option.some(element$1._0),
              0
            ];
    }
    var match$2 = element$1._0;
    return [
            Caml_option.nullable_to_opt(match$2.parentElement.firstChild),
            match$2.text.length
          ];
  };
  var match = ListUtils$SmartcutsMacros.last(textContents);
  var nodeAndEndOffsetOfLastTextSegment;
  if (match !== undefined) {
    if (match.TAG === /* TextSegment */0) {
      var element$1 = match._0;
      if (element$1.TAG === /* NonEmptySegment */0) {
        var match$1 = element$1._0;
        nodeAndEndOffsetOfLastTextSegment = [
          Caml_option.nullable_to_opt(match$1.parentElement.childNodes.item(match$1.textNodeIndex)),
          match$1.text.length
        ];
      } else {
        nodeAndEndOffsetOfLastTextSegment = [
          Caml_option.some(element$1._0),
          0
        ];
      }
    } else {
      var element$2 = match._0;
      if (element$2.TAG === /* NonEmptySegment */0) {
        var match$2 = element$2._0;
        nodeAndEndOffsetOfLastTextSegment = [
          Caml_option.nullable_to_opt(match$2.parentElement.firstChild),
          match$2.text.length
        ];
      } else {
        nodeAndEndOffsetOfLastTextSegment = [
          Caml_option.some(element$2._0),
          0
        ];
      }
    }
  } else {
    nodeAndEndOffsetOfLastTextSegment = [
      undefined,
      0
    ];
  }
  if (typeof semantic === "number") {
    return applySelection(nodeOfTextSegmentAtIndex(0), nodeAndEndOffsetOfLastTextSegment[0], 0, nodeAndEndOffsetOfLastTextSegment[1]);
  }
  switch (semantic.TAG | 0) {
    case /* SelectAll_FromNthParagraph */0 :
        var match$3 = TextContents$SmartcutsMacros.Generic.locateNthParagraph(semantic._0, textContents);
        var startNode = match$3 !== undefined ? nodeOfTextSegmentAtIndex(match$3[0]) : undefined;
        return applySelection(startNode, nodeAndEndOffsetOfLastTextSegment[0], 0, nodeAndEndOffsetOfLastTextSegment[1]);
    case /* SelectAll_ToNthParagraphEnds */1 :
        var match$4 = TextContents$SmartcutsMacros.Generic.locateNthParagraph(semantic._0, textContents);
        var match$5 = match$4 !== undefined ? nodeAndEndOffsetOfTextSegmentAtIndex(match$4[1]) : [
            undefined,
            0
          ];
        return applySelection(nodeOfTextSegmentAtIndex(0), match$5[0], 0, match$5[1]);
    case /* SelectAll_AfterPrefixInNthParagraph */2 :
        var prefix = semantic._0;
        var func = TextContents$SmartcutsMacros.Generic.locateNthParagraph;
        var arg = Curry._2(func, semantic._1, textContents);
        var match$6 = (function (param) {
              return OptionUtils$SmartcutsMacros.getExn(param, arg);
            })("Expected to locateNathParagraph when applying SelectAll_AfterPrefixInNthParagraph semantic");
        var result = ListUtils$SmartcutsMacros.shortcut((function (textContent) {
                if (textContent.TAG !== /* TextSegment */0) {
                  return ;
                }
                var element = textContent._0;
                if (element.TAG !== /* NonEmptySegment */0) {
                  return [
                          Caml_option.some(element._0),
                          0
                        ];
                }
                var match = element._0;
                var prefixStarts = match.text.indexOf(prefix);
                if (prefixStarts === -1) {
                  return ;
                }
                var node = match.parentElement.childNodes.item(match.textNodeIndex);
                return [
                        (node == null) ? undefined : Caml_option.some(node),
                        prefixStarts + prefix.length | 0
                      ];
              }), ListUtils$SmartcutsMacros.take(match$6[0], textContents));
        var match$7 = result !== undefined ? result : [
            undefined,
            0
          ];
        var match$8 = nodeAndEndOffsetOfTextSegmentAtIndex(match$6[1]);
        return applySelection(match$7[0], match$8[0], match$7[1], match$8[1]);
    case /* SelectAll_BeforeSuffixInNthParagraph */3 :
        var suffix = semantic._0;
        var func$1 = TextContents$SmartcutsMacros.Generic.locateNthParagraph;
        var arg$1 = Curry._2(func$1, semantic._1, textContents);
        var match$9 = (function (param) {
              return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
            })("Expected to locateNathParagraph when applying SelectAll_BeforeSuffixInNthParagraph semantic");
        var startIndex = match$9[0];
        var result$1 = ListUtils$SmartcutsMacros.shortcut((function (textContent) {
                if (textContent.TAG !== /* TextSegment */0) {
                  return ;
                }
                var element = textContent._0;
                if (element.TAG !== /* NonEmptySegment */0) {
                  return [
                          Caml_option.some(element._0),
                          0
                        ];
                }
                var match = element._0;
                var offset = match.text.indexOf(suffix);
                if (offset === -1) {
                  return ;
                }
                var node = match.parentElement.childNodes.item(match.textNodeIndex);
                return [
                        (node == null) ? undefined : Caml_option.some(node),
                        offset
                      ];
              }), ListUtils$SmartcutsMacros.take(startIndex, textContents));
        var match$10 = result$1 !== undefined ? result$1 : [
            undefined,
            0
          ];
        return applySelection(nodeOfTextSegmentAtIndex(startIndex), match$10[0], 0, match$10[1]);
    case /* SelectInNthParagraph */4 :
        var nthParagraph = semantic._0;
        return SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.applyToDom(dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic._1).then(function (result) {
                    if (result.TAG === /* Ok */0) {
                      return Promise.resolve({
                                  TAG: /* Ok */0,
                                  _0: undefined
                                });
                    }
                    var nonInputSemanticApplicationError = result._0;
                    if (typeof nonInputSemanticApplicationError === "number" || nonInputSemanticApplicationError.TAG !== /* NonInputSelectionSemanticError */0) {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: nonInputSemanticApplicationError
                                });
                    } else {
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: {
                                    TAG: /* ContentEditableSelectionSemanticError */4,
                                    _0: {
                                      TAG: /* CouldNotApplyNonInputSelectionSemanticInNthParagraph */1,
                                      _0: nthParagraph,
                                      _1: nonInputSemanticApplicationError._0
                                    }
                                  }
                                });
                    }
                  });
    case /* SelectParagraphs */5 :
        var match$11 = TextContents$SmartcutsMacros.Generic.locateNthParagraph(semantic._0, textContents);
        var match$12 = TextContents$SmartcutsMacros.Generic.locateNthParagraph(semantic._1, textContents);
        if (match$11 === undefined) {
          return Util$SmartcutsMacros.logAndRaiseJsError("Expected to locate start and end paragraph");
        }
        if (match$12 === undefined) {
          return Util$SmartcutsMacros.logAndRaiseJsError("Expected to locate start and end paragraph");
        }
        var match$13 = nodeAndEndOffsetOfTextSegmentAtIndex(match$12[1]);
        return applySelection(nodeOfTextSegmentAtIndex(match$11[0]), match$13[0], 0, match$13[1]);
    case /* SelectBetweenIndexes */6 :
        var match$14 = semantic._1;
        var match$15 = semantic._0;
        var locateNodeAndOffset = function (nthParagraph, offsetFromParagraphStarts) {
          var match = TextContents$SmartcutsMacros.Generic.locateNthParagraph(nthParagraph, textContents);
          if (match !== undefined) {
            return ListUtils$SmartcutsMacros.shortcutWithState(offsetFromParagraphStarts, (function (remainingOffset, textContent) {
                          var textLength = TextContents$SmartcutsMacros.textGet(textContent).length;
                          if (remainingOffset > textLength) {
                            return [
                                    remainingOffset - textLength | 0,
                                    undefined
                                  ];
                          }
                          var element;
                          if (textContent.TAG === /* TextSegment */0) {
                            var element$1 = textContent._0;
                            if (element$1.TAG === /* NonEmptySegment */0) {
                              var match = element$1._0;
                              return [
                                      remainingOffset,
                                      [
                                        Caml_option.nullable_to_opt(match.parentElement.childNodes.item(match.textNodeIndex)),
                                        remainingOffset
                                      ]
                                    ];
                            }
                            element = element$1._0;
                          } else {
                            var element$2 = textContent._0;
                            if (element$2.TAG === /* NonEmptySegment */0) {
                              return [
                                      remainingOffset,
                                      [
                                        Caml_option.nullable_to_opt(element$2._0.parentElement.firstChild),
                                        remainingOffset
                                      ]
                                    ];
                            }
                            element = element$2._0;
                          }
                          return [
                                  remainingOffset,
                                  [
                                    Caml_option.some(element),
                                    remainingOffset
                                  ]
                                ];
                        }), ListUtils$SmartcutsMacros.drop(match[0], ListUtils$SmartcutsMacros.take(match[1], textContents)));
          }
          
        };
        var match$16 = locateNodeAndOffset(match$15[0], match$15[1]);
        var match$17 = locateNodeAndOffset(match$14[0], match$14[1]);
        if (match$16 !== undefined && match$17 !== undefined) {
          return applySelection(match$16[0], match$17[0], match$16[1], match$17[1]);
        } else {
          return Util$SmartcutsMacros.logAndRaiseJsError("Expected to locate start and end paragraph");
        }
    
  }
}

function selectInsideContentEditableLocatedAtSelector(selector, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
  return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, false, undefined, undefined, undefined, selector).then(function (result_contentEditableHost) {
              if (result_contentEditableHost.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result_contentEditableHost._0
                          });
              }
              var contentEditableHost = result_contentEditableHost._0;
              return DOM__Element$SmartcutsMacros.waitForAnyPossibleOverlayToDisappear(contentEditableHost, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, undefined).then(function (result) {
                          if (result.TAG === /* Ok */0) {
                            return selectInsideContentEditable(contentEditableHost, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic);
                          } else {
                            return Promise.resolve({
                                        TAG: /* Error */1,
                                        _0: result._0
                                      });
                          }
                        });
            });
}

function toHumanReadable(semantic) {
  if (typeof semantic === "number") {
    return "All content inside the editor";
  }
  switch (semantic.TAG | 0) {
    case /* SelectAll_FromNthParagraph */0 :
        return "From the " + (StringUtils$SmartcutsMacros.withOrd(semantic._0 + 1 | 0) + " to the end");
    case /* SelectAll_ToNthParagraphEnds */1 :
        return "Until the " + (StringUtils$SmartcutsMacros.withOrd(semantic._0 + 1 | 0) + " paragraph");
    case /* SelectAll_AfterPrefixInNthParagraph */2 :
        return "From \"" + semantic._0 + "\" in " + (StringUtils$SmartcutsMacros.withOrd(semantic._1 + 1 | 0) + " to the end");
    case /* SelectAll_BeforeSuffixInNthParagraph */3 :
        return "Until \"" + semantic._0 + "\" " + (StringUtils$SmartcutsMacros.withOrd(semantic._1 + 1 | 0) + " paragraph");
    case /* SelectInNthParagraph */4 :
        return SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.Semantic.stringify(semantic._1) + (" in " + (StringUtils$SmartcutsMacros.withOrd(semantic._0 + 1 | 0) + " paragraph"));
    case /* SelectParagraphs */5 :
        return "From the " + (StringUtils$SmartcutsMacros.withOrd(semantic._0 + 1 | 0) + (" paragraphuntil the end of " + (StringUtils$SmartcutsMacros.withOrd(semantic._1 + 1 | 0) + " paragraph")));
    case /* SelectBetweenIndexes */6 :
        var match = semantic._1;
        var match$1 = semantic._0;
        return "Between position " + match$1[1] + " in the " + (StringUtils$SmartcutsMacros.withOrd(match$1[0] + 1 | 0) + (" paragraph to position " + match[1] + " in the " + (StringUtils$SmartcutsMacros.withOrd(match[0] + 1 | 0) + " paragraph")));
    
  }
}

var Semantic = {
  t_encode: t_encode,
  t_decode: t_decode,
  selectInsideContentEditable: selectInsideContentEditable,
  selectInsideContentEditableLocatedAtSelector: selectInsideContentEditableLocatedAtSelector,
  toHumanReadable: toHumanReadable
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "semantics",
                Decco.arrayToJson(t_encode, v.semantics)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var semantics = Decco.arrayFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantics"), null));
    if (semantics.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                selector: selector._0,
                semantics: semantics._0
              }
            };
    }
    var e = semantics._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".semantics" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function ofSelection(contentEditableHost, textContents, selection) {
  var semantics;
  if (selection.TAG === /* SingleNode */0) {
    var match = selection._0;
    var endOffset = match.endOffset;
    var startOffset = match.startOffset;
    var textNode = match.textNode;
    var exit = 0;
    var exit$1 = 0;
    var text;
    if (textContents) {
      var match$1 = textContents.hd;
      if (match$1.TAG === /* TextSegment */0) {
        var match$2 = match$1._0;
        if (match$2.TAG === /* NonEmptySegment */0) {
          if (textContents.tl) {
            exit = 1;
          } else {
            text = match$2._0.text;
            exit$1 = 2;
          }
        } else if (textContents.tl) {
          exit = 1;
        } else {
          exit$1 = 3;
        }
      } else {
        var match$3 = match$1._0;
        if (match$3.TAG === /* NonEmptySegment */0) {
          if (textContents.tl) {
            exit = 1;
          } else {
            text = match$3._0.text;
            exit$1 = 2;
          }
        } else if (textContents.tl) {
          exit = 1;
        } else {
          exit$1 = 3;
        }
      }
    } else {
      exit = 1;
    }
    switch (exit$1) {
      case 2 :
          if (startOffset === 0 && endOffset === text.length) {
            semantics = [/* SelectAll_InsideContenEditable */0];
          } else {
            exit = 1;
          }
          break;
      case 3 :
          if (startOffset === 0 && endOffset === 0) {
            semantics = [/* SelectAll_InsideContenEditable */0];
          } else {
            exit = 1;
          }
          break;
      
    }
    if (exit === 1) {
      var nonInputSemantics = SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.ofSelection(selection);
      var func = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.search;
      var func$1 = Curry._1(func, match.elementNode.domElementRepresentation.domElementIdentifier);
      var maybeResult = Curry._2(func$1, textNode !== undefined ? textNode.siblingIndex : -1, textContents);
      if (maybeResult !== undefined) {
        var nthParagraph = maybeResult.nthParagraph;
        semantics = Belt_Array.map(nonInputSemantics, (function (semantic) {
                return {
                        TAG: /* SelectInNthParagraph */4,
                        _0: nthParagraph,
                        _1: semantic
                      };
              }));
      } else {
        semantics = [];
      }
    }
    
  } else {
    var match$4 = selection._0;
    var match$5 = match$4.end_;
    var endOffset$1 = match$5.offset;
    var endTextNode = match$5.textNode;
    var match$6 = match$4.start;
    var startOffset$1 = match$6.offset;
    var startTextNode = match$6.textNode;
    var textNodeIndexForStart = startTextNode !== undefined ? startTextNode.siblingIndex : -1;
    var textNodeIndexForEnd = endTextNode !== undefined ? endTextNode.siblingIndex : -1;
    var func$2 = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.search;
    var func$3 = Curry._1(func$2, match$6.elementNode.domElementRepresentation.domElementIdentifier);
    var arg = Curry._2(func$3, textNodeIndexForStart, textContents);
    var startPointer = (function (param) {
          return OptionUtils$SmartcutsMacros.getExn(param, arg);
        })("Expected to find startPointer");
    var func$4 = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.search;
    var func$5 = Curry._1(func$4, match$5.elementNode.domElementRepresentation.domElementIdentifier);
    var arg$1 = Curry._2(func$5, textNodeIndexForEnd, textContents);
    var endPointer = (function (param) {
          return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
        })("Expected to find endPointer");
    var fullText = TextContents$SmartcutsMacros.Generic.fullText(textContents);
    var match$7 = SelectionSemantics__Shared$SmartcutsMacros.SemanticsPrefixSuffix.getPrefixAndSuffixWord(fullText, TextContents$SmartcutsMacros.Generic.offsetFormBeginning(startPointer.index, startOffset$1, textContents), fullText, TextContents$SmartcutsMacros.Generic.offsetFormBeginning(endPointer.index, endOffset$1, textContents));
    var suffixWord = match$7[1];
    var prefixWord = match$7[0];
    var startIndex = startPointer.index;
    var nthParagraph$1 = startPointer.nthParagraph;
    var exit$2 = 0;
    var exit$3 = 0;
    if (startIndex !== 0 || !(startOffset$1 === 0 && endPointer.index === List.length(textContents) && endOffset$1 === TextContents$SmartcutsMacros.textGet(endPointer.textContent).length)) {
      exit$3 = 2;
    } else {
      semantics = [/* SelectAll_InsideContenEditable */0];
    }
    if (exit$3 === 2) {
      if (endPointer.index === List.length(textContents)) {
        semantics = startIndex === startPointer.currentParagraphStartsAtIndex && startOffset$1 === 0 ? [{
              TAG: /* SelectAll_FromNthParagraph */0,
              _0: nthParagraph$1
            }] : (
            prefixWord !== undefined ? [{
                  TAG: /* SelectAll_AfterPrefixInNthParagraph */2,
                  _0: prefixWord[1],
                  _1: nthParagraph$1
                }] : Util$SmartcutsMacros.logAndRaiseJsError("Expected to find a prefix")
          );
      } else if (startIndex !== 0) {
        exit$2 = 1;
      } else {
        var nthParagraph$2 = endPointer.nthParagraph;
        if (startOffset$1 === 0 && endOffset$1 === TextContents$SmartcutsMacros.textGet(endPointer.textContent).length) {
          semantics = TextContents$SmartcutsMacros.Generic.isAtParagraphBoundary(endPointer.index + 1 | 0, textContents) ? [{
                TAG: /* SelectAll_ToNthParagraphEnds */1,
                _0: nthParagraph$2
              }] : (
              suffixWord !== undefined ? [{
                    TAG: /* SelectAll_BeforeSuffixInNthParagraph */3,
                    _0: suffixWord[1],
                    _1: nthParagraph$2
                  }] : Util$SmartcutsMacros.logAndRaiseJsError("Expected to find a suffix")
            );
        } else {
          exit$2 = 1;
        }
      }
    }
    if (exit$2 === 1) {
      var endIndex = endPointer.index;
      var endParagraph = endPointer.nthParagraph;
      var indexOfStartParagraph = startPointer.currentParagraphStartsAtIndex;
      if (nthParagraph$1 === endParagraph) {
        var nonInputSemantics$1 = SelectionSemantics__NonInputSelectionSemantics$SmartcutsMacros.ofSelection(selection);
        semantics = Belt_Array.map(nonInputSemantics$1, (function (semantic) {
                return {
                        TAG: /* SelectInNthParagraph */4,
                        _0: nthParagraph$1,
                        _1: semantic
                      };
              }));
      } else if (startOffset$1 === 0 && startIndex === indexOfStartParagraph && endOffset$1 === TextContents$SmartcutsMacros.textGet(endPointer.textContent).length && TextContents$SmartcutsMacros.Generic.isAtParagraphBoundary(endIndex + 1 | 0, textContents)) {
        semantics = [{
            TAG: /* SelectParagraphs */5,
            _0: nthParagraph$1,
            _1: endParagraph
          }];
      } else {
        var startOffsetInParagraph = TextContents$SmartcutsMacros.Generic.offsetFormBeginningOfParagraph(startIndex, indexOfStartParagraph, startOffset$1, textContents);
        var endOffsetInParagraph = TextContents$SmartcutsMacros.Generic.offsetFormBeginningOfParagraph(endIndex, endPointer.currentParagraphStartsAtIndex, endOffset$1, textContents);
        semantics = [{
            TAG: /* SelectBetweenIndexes */6,
            _0: [
              nthParagraph$1,
              startOffsetInParagraph
            ],
            _1: [
              endParagraph,
              endOffsetInParagraph
            ]
          }];
      }
    }
    
  }
  return {
          selector: contentEditableHost.selector,
          semantics: semantics
        };
}

function stringify(semantics) {
  return "[" + ($$Array.map(toHumanReadable, semantics).join(", ") + "]");
}

var SemanticsPrefixSuffix;

var NonInputSelection;

var NonInputSelectionSemantics;

exports.SemanticsPrefixSuffix = SemanticsPrefixSuffix;
exports.NonInputSelection = NonInputSelection;
exports.NonInputSelectionSemantics = NonInputSelectionSemantics;
exports.Semantic = Semantic;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.ofSelection = ofSelection;
exports.stringify = stringify;
/* Util-SmartcutsMacros Not a pure module */
